export default __webpack_public_path__ + "static/media/layer-0.f0c3743d.svg";